import PropertyTransactionHistoryContainer from 'legacy/containers/property-transaction-history';

import PropertyExplorerSection from 'legacy/components/PropertyExplorerSection';
import PropertyExplorerSectionHeading from 'legacy/components/PropertyExplorerSectionHeading';

import { PropertyTransactionHistorySection as theme } from 'legacy/css-modules';

const PropertyTransactionHistorySection = ({ addressId }) => {
  return (
    <PropertyExplorerSection
      dataHcName="transaction-history-section"
      className={theme.PropertyTransactionHistorySection}
    >
      <PropertyExplorerSectionHeading dataHcName="transaction-history-heading">
        Transaction History
      </PropertyExplorerSectionHeading>
      <PropertyTransactionHistoryContainer addressId={addressId} />
    </PropertyExplorerSection>
  );
};

export default PropertyTransactionHistorySection;
